import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/containers/accordion.containers'
import Table from '../../../../../common/components/table'

export default function ShipmentItemInfoComponent({ rowData, columnDefs }: any) {

  return (
    <>
      <AccordionContainer
        child={
          <Table
            columnData={columnDefs}
            rowData={rowData}
          />

        }
        expandedPanel="basicInfo"
        headerTitle="Order Item Info"
      />


    </>
  )
}